import type { ICellEditorParams } from "ag-grid-community";
import { forwardRef, useCallback, useImperativeHandle, useState } from "react";
import { DateOnlyPicker } from "widgets";

import type { CellEditorParams } from "../../cell-editor-factory.js";
import { TableCell } from "../core/TableCell.js";

export const DateCellEditor = forwardRef((props: ICellEditorParams<string> & CellEditorParams, ref) => {
  // useState initialization: make sure to init a proper date value, in case the user does not pick any date
  const [date, setDate] = useState<string>(props.value);

  const c = useCallback(() => {
    return {
      // the final tag to send to the grid, on completion of editing
      getValue() {
        return date;
      },
    };
  }, [date]);

  /* Component Editor Lifecycle methods */
  useImperativeHandle(ref, c);

  return (
    <TableCell editor>
      <DateOnlyPicker
        ISOFormattedDate={date}
        onChange={(date) => setDate(date ?? "")}
        onClose={() => setTimeout(() => props.stopEditing())}
        autoFocus={true}
        defaultOpen={false}
        preventTimezoneConversion={true}
      />
    </TableCell>
  );
});
